// правильно сделать в компоненте интерфейсы и передачу пропсов/интерфейсов
import React, { useState, useCallback, memo, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { Tab, TabsGroup } from '@root-gipro/shared/TabsComponents/CustomTabs'
import { ITabsNavLink } from '@root-gipro/shared/TabsComponents/tabs.props'
import { usePageLink } from '@root-gipro/shared/hooks/usePageLink'
import style from '@root-gipro/shared/TabsComponents/TabsComponents.module.scss'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { IState } from '@root-gipro/store/interfaces'
import { fetchPublicUserProjectInfo } from '@root-gipro/store/actions'
import { ROSSETI_ID } from '@root-gipro/modules/userProjects/utils/helpers'
import { showNotify } from '@root-gipro/modules/notify/store/actions'

export const TabsNavLink: React.FC<ITabsNavLink> = memo(({ types, path }) => {

  const roleId = localStorage.getItem('roleId');
	const { currentPath }: any = usePageLink()
	const dispatch = useDispatch()
	const { projectObj, originalObj } = useSelector((state: IState) => state.userProjects)
	const companyId = useMemo(() => Number(localStorage.getItem('companyId')), [])

	const [selectedTab, setSelectedTab] = useState<string>(currentPath)
	useEffect(() => {
		setSelectedTab(currentPath)
	}, [currentPath])

	useEffect(() => {
		if (projectObj.unc_sort) {
			dispatch(fetchPublicUserProjectInfo(projectObj.unc_sort))
		}
	}, [])

	const history = useHistory()

	const years = useMemo(() => {
		let years: any[] = []

		if (originalObj && originalObj.years) {
			years = Object.keys(originalObj.years)

			return years
				.filter(year => Number(year) >= 2018)
				.map(year => {
					return [year, originalObj.years[year]?.offer ?? 0]
				})
		}
	}, [originalObj])

	const handleChange = useCallback(
		(_: React.ChangeEvent<{}>, newRoute: string) => {
			const lastSegment = newRoute.split('/').filter(Boolean).pop()

			// Проверка на переход в "rates"
			if (lastSegment === 'rates' && years?.length && !originalObj.additionalFundingOffer) {
				const isValid = years.some(([_, value]) => Number(value) > 0)

				if (!isValid) {
					dispatch(
						showNotify({
							type: 'warning',
							message: 'Не заполнены следующие обязательные поля: Объем финансирования инвестиций по годам (с НДС)',
						})
					)
					return
				}
			}

			history.push(newRoute)
			setSelectedTab(newRoute)
		},
		[types, years, projectObj.additionalFundingOffer]
	)

  return (
		<TabsGroup value={selectedTab} onChange={handleChange} className={style.checkPlateTabs}>
			{types &&
				types.map((type: any) => {
					if (type.title == 'Технические решения' && ROSSETI_ID !== companyId) {
						return null
					}

          if(type.title === 'РПС' && (roleId && (+roleId > 3))) {
            return null;
          }
          
					return (
						type.tags.includes(path) && (
							<Tab
								className={cn({
									[style.active]: selectedTab === type.path,
								})}
								disableRipple
								key={type.path}
								label={type.title}
								value={type.path}
								disabled={path === '/user-projects' && !projectObj?.id}
							/>
						)
					)
				})}
		</TabsGroup>
	)
})
